import { TaskType, TaskTypeRequiredFields } from '../types/interfaces';

import { ObjectForSelectionTemplate } from './ObjectForSelectionTemplate';

export const DEFAULT_TASK_TYPE_REQUIRED_FIELDS: TaskTypeRequiredFields = {
  name: false,
  asset: false,
  department: false,
  employees: false,
  plannedStartDate: false,
  actualStartDate: false,
  plannedEndDate: false,
  actualEndDate: false,
  description: false,
  attachment: false,
  plannedOperations: false,
  actualOperations: false
};

export const TasksTypeTemplate: TaskType = {
  id: '',
  taskType: '',
  statusTransition: ObjectForSelectionTemplate,
  statusTransitionName: '',
  planningAlgorithm: ObjectForSelectionTemplate,
  processingTime: null,
  defaultOperations: [],
  priority: 0,
  isCustomEffort: true,
  responseTime: '',
  resolutionTime: '',
  requiredEmployees: 1,
  requiredFields: { ...DEFAULT_TASK_TYPE_REQUIRED_FIELDS },
  inventory: false,
  assignDepartmentOnSave: false
};
